import { NgModule } from '@angular/core';
import { DdayPipe } from './dday.pipe';


@NgModule({
  declarations: [
    DdayPipe
  ],
  exports:[
    DdayPipe    
  ]
})
export class DdayModule { }


